import { useState, useEffect, useRef } from "react";

export function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    if (ref.current) observer.observe(ref.current);

    // Fail-safe: some environments (older browsers, certain mobile webviews,
    // an observer that never fires for a reason we can't detect) never call
    // back at all. Content wrapped in this hook must not stay invisible
    // forever, so force it visible after a short grace period regardless.
    const fallback = setTimeout(() => setInView(true), 1500);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, [threshold]);

  return { ref, inView };
}
